export default __webpack_public_path__ + "static/media/logo-fav-sidebar.92ba9ea4.svg";